import { useEffect, useState } from 'react'
import { useAuth } from '../../Contexts/AuthContext'
import { isEmailInSongManagementTeam } from '../../Helpers/RestrictedEmailsArray'
import useAdminAccess from '../../services/hooks/useAdminAccess'
import useReadOnly from '../../services/hooks/useReadOnly'
import { permissions } from '../../constants/roles'
import { isUserAllowed } from '../../utils/allowlistManager'
import useIngestAccess from '../../services/hooks/useIngestAccess'

const songManagementTeamLinks = [
  {
    name: 'Songs',
    iconSelected: './icons/song-icon-selected.png',
    iconUnselected: './icons/song-icon.png',
    alt: 'songs',
    route: '/songs/all',
    selectedIfMatchesRoutes: ['/all', '/edit-song', '/song'],
  },
  {
    name: 'Reports',
    iconSelected: './icons/report-icon-selected.png',
    iconUnselected: './icons/report-icon.png',
    alt: 'reports',
    route: '/reports',
    selectedIfMatchesRoutes: ['/reports'],
  },
]

const adminLinks = [
  {
    name: 'Artists',
    iconSelected: './icons/artist-icon-selected.png',
    iconUnselected: './icons/artist-icon.png',
    alt: 'artists',
    route: '/artists',
    selectedIfMatchesRoutes: [
      '/artists',
      '/artist',
      '/albums',
      '/album',
      '/feels',
    ],
  },
  {
    name: 'Songs',
    iconSelected: './icons/song-icon-selected.png',
    iconUnselected: './icons/song-icon.png',
    alt: 'songs',
    route: '/songs/all',
    selectedIfMatchesRoutes: ['/all', '/edit-song', '/song'],
  },
  {
    name: 'Collections',
    iconSelected: './icons/collections-icon-selected.png',
    iconUnselected: './icons/collections-icon.png',
    alt: 'collections',
    route: '/collections',
    selectedIfMatchesRoutes: ['/collections', '/featured-collection-update'],
  },
  {
    name: 'Data',
    iconSelected: './icons/data-icon-selected.png',
    iconUnselected: './icons/data-icon.png',
    alt: 'data',
    route: '/data/superset-dash',
    selectedIfMatchesRoutes: ['/data'],
  },
  {
    name: 'Reports',
    iconSelected: './icons/report-icon-selected.png',
    iconUnselected: './icons/report-icon.png',
    alt: 'reports',
    route: '/reports',
    selectedIfMatchesRoutes: ['/reports'],
  },
  {
    name: 'Pitch',
    iconSelected: './icons/pitch-icon-selected.png',
    iconUnselected: './icons/pitch-icon.png',
    alt: 'pitch',
    route: '/pitch',
    selectedIfMatchesRoutes: ['/pitch'],
  },
  {
    name: 'FAQ',
    iconSelected: './icons/faq-selected.png',
    iconUnselected: './icons/faq-icon.png',
    alt: 'faq',
    route: '/faq',
    selectedIfMatchesRoutes: ['/faq'],
  },
  {
    sectionLabel: 'Internal Tools',
  },
  {
    name: 'All Reports',
    iconSelected: './icons/report-icon-selected.png',
    iconUnselected: './icons/report-icon.png',
    alt: 'all-reports',
    route: '/all-reports',
    selectedIfMatchesRoutes: ['/all-reports'],
  },
  {
    name: 'Codes',
    iconSelected: './icons/invite-code-icon-selected.png',
    iconUnselected: './icons/invite-code-icon.png',
    alt: 'codes',
    route: '/codes',
    selectedIfMatchesRoutes: ['/codes'],
  },
  {
    name: 'ISRC Review',
    iconSelected: './icons/barcode-icon.svg',
    iconUnselected: './icons/barcode-icon.svg',
    alt: 'isrc-review',
    route: '/songs/isrc-review',
    selectedIfMatchesRoutes: ['/isrc-review'],
  },
  {
    name: 'FeelsSync Jobs',
    iconSelected: './icons/song-icon-selected.png',
    iconUnselected: './icons/song-icon.png',
    alt: 'feelsync-jobs',
    route: '/feelsyncjobs',
    selectedIfMatchesRoutes: ['/feelsyncjobs'],
  },
  {
    name: 'Ingest',
    iconSelected: './icons/song-icon-selected.png',
    iconUnselected: './icons/song-icon.png',
    alt: 'ingest',
    route: '/ingest',
    selectedIfMatchesRoutes: ['/ingest'],
  },
  {
    name: 'Generated',
    iconSelected: './icons/pencil-sparkles-icon.svg',
    iconUnselected: './icons/pencil-sparkles-icon.svg',
    alt: 'review-generated',
    route: '/feels-review-by-collection',
    selectedIfMatchesRoutes: ['/feels-review-by-collection'],
  },
  {
    name: 'User Made',
    iconSelected: './icons/pencil-icon.svg',
    iconUnselected: './icons/pencil-icon.svg',
    alt: 'review-user-made',
    route: '/feels-review',
    selectedIfMatchesRoutes: ['/feels-review'],
  },
]

const internalLinks = [
  ...adminLinks,
  {
    name: 'Feels Drawer',
    iconSelected: './icons/song-icon-selected.png',
    iconUnselected: './icons/song-icon.png',
    alt: 'feels-drawer',
    route: '/feels-drawer',
    selectedIfMatchesRoutes: ['/feels-drawer'],
  },
  {
    name: 'Scream Room',
    iconSelected: './icons/song-icon-selected.png',
    iconUnselected: './icons/song-icon.png',
    alt: 'scream-room',
    route: '/scream-room',
    selectedIfMatchesRoutes: ['/scream-room'],
  },
  {
    name: 'Filters',
    iconSelected: './icons/song-icon-selected.png',
    iconUnselected: './icons/song-icon.png',
    alt: 'filters',
    route: '/filters',
    selectedIfMatchesRoutes: ['/filters'],
  },
]

const defaultLinks = [
  {
    name: 'Artists',
    iconSelected: './icons/artist-icon-selected.png',
    iconUnselected: './icons/artist-icon.png',
    alt: 'artists',
    route: '/artists',
    selectedIfMatchesRoutes: [
      '/artists',
      '/artist',
      '/albums',
      '/album',
      '/feels',
    ],
  },
  {
    name: 'Songs',
    iconSelected: './icons/song-icon-selected.png',
    iconUnselected: './icons/song-icon.png',
    alt: 'songs',
    route: '/songs/all',
    selectedIfMatchesRoutes: ['/all', '/edit-song', '/song'],
  },
  // {
  //   name: 'Music Messages',
  //   iconSelected: './icons/dashboard-selected.png',
  //   iconUnselected: './icons/dashboard-unselected.png',
  //   alt: 'music messages',
  //   route: '/dashboard',
  //   selectedIfMatchesRoutes: [
  //     '/dashboard',
  //     '/create-new-feel-step-1',
  //     '/create-new-feel-step-2',
  //     '/feel',
  //     '/feels',
  //   ],
  // },
  {
    name: 'Data',
    iconSelected: './icons/data-icon-selected.png',
    iconUnselected: './icons/data-icon.png',
    alt: 'data',
    route: '/data/superset-dash',
    selectedIfMatchesRoutes: ['/data'],
  },
  {
    name: 'Reports',
    iconSelected: './icons/report-icon-selected.png',
    iconUnselected: './icons/report-icon.png',
    alt: 'reports',
    route: '/reports',
    selectedIfMatchesRoutes: ['/reports'],
  },

  {
    name: 'Pitch',
    iconSelected: './icons/pitch-icon-selected.png',
    iconUnselected: './icons/pitch-icon.png',
    alt: 'pitch',
    route: '/pitch',
    selectedIfMatchesRoutes: ['/pitch'],
  },
  {
    name: 'Codes',
    iconSelected: './icons/invite-code-icon-selected.png',
    iconUnselected: './icons/invite-code-icon.png',
    alt: 'codes',
    route: '/codes',
    selectedIfMatchesRoutes: ['/codes'],
  },
  {
    name: 'FAQ',
    iconSelected: './icons/faq-selected.png',
    iconUnselected: './icons/faq-icon.png',
    alt: 'faq',
    route: '/faq',
    selectedIfMatchesRoutes: ['/faq'],
  },
]

const viewerLinks = [
  {
    name: 'Artists',
    iconSelected: './icons/artist-icon-selected.png',
    iconUnselected: './icons/artist-icon.png',
    alt: 'artists',
    route: '/artists',
    selectedIfMatchesRoutes: [
      '/artists',
      '/artist',
      '/albums',
      '/album',
      '/feels',
    ],
  },
  {
    name: 'Songs',
    iconSelected: './icons/song-icon-selected.png',
    iconUnselected: './icons/song-icon.png',
    alt: 'songs',
    route: '/songs/all',
    selectedIfMatchesRoutes: ['/all', '/edit-song', '/song'],
  },
  {
    name: 'Data',
    iconSelected: './icons/data-icon-selected.png',
    iconUnselected: './icons/data-icon.png',
    alt: 'data',
    route: '/data/superset-dash',
    selectedIfMatchesRoutes: ['/data'],
  },
  {
    name: 'Reports',
    iconSelected: './icons/report-icon-selected.png',
    iconUnselected: './icons/report-icon.png',
    alt: 'reports',
    route: '/reports',
    selectedIfMatchesRoutes: ['/reports'],
  },

  {
    name: 'Pitch',
    iconSelected: './icons/pitch-icon-selected.png',
    iconUnselected: './icons/pitch-icon.png',
    alt: 'pitch',
    route: '/pitch',
    selectedIfMatchesRoutes: ['/pitch'],
  },
  {
    name: 'Codes',
    iconSelected: './icons/invite-code-icon-selected.png',
    iconUnselected: './icons/invite-code-icon.png',
    alt: 'codes',
    route: '/codes',
    selectedIfMatchesRoutes: ['/codes'],
  },
  {
    name: 'FAQ',
    iconSelected: './icons/faq-selected.png',
    iconUnselected: './icons/faq-icon.png',
    alt: 'faq',
    route: '/faq',
    selectedIfMatchesRoutes: ['/faq'],
  },
]

export default function useSidebar() {
  const ingestAccess = useIngestAccess()
  const canUseIngest = ingestAccess.data?.enabled === true && !ingestAccess.error
  const { isInternal, isAdmin } = useAdminAccess()
  const { getCurrentUser } = useAuth()
  const isSongManagementTeam = isEmailInSongManagementTeam(
    getCurrentUser()?.email
  )

  const { isReadOnly: isSongReadOnly } = useReadOnly(permissions.r.music_song)

  const [sidebarLinks, setSidebarLinks] = useState([])
  const [hasCodesAccess, setHasCodesAccess] = useState(false)
  // Check if user has authorized email domain AND is in allowlist for Codes access
  useEffect(() => {
    const checkCodesAccess = async () => {
      const userEmail = getCurrentUser()?.email || ''
      const allowedDomains = ['@musicmakesusfeels.com', '@feelsmusic.com']
      const hasDomainAccess = allowedDomains.some(domain =>
        userEmail.endsWith(domain)
      )
      const isInAllowlist = await isUserAllowed(userEmail)
      const codesAccess = hasDomainAccess && isInAllowlist
      setHasCodesAccess(codesAccess)
    }

    checkCodesAccess()
  }, [getCurrentUser])

  // Filter out Codes link if user doesn't have access
  const filterLinksForCodesAccess = links => {
    const visible = links.filter(link => (hasCodesAccess || link.name !== 'Codes') && (canUseIngest || link.route !== '/ingest'))
    if (canUseIngest && !visible.some(link=>link.route === '/ingest')) visible.push(adminLinks.find(link=>link.route === '/ingest'))
    return visible
  }

  const songManagementTeamLinksWithIndex = filterLinksForCodesAccess(
    songManagementTeamLinks
  ).map((link, index) => ({ ...link, index }))
  const adminLinksWithIndex = filterLinksForCodesAccess(adminLinks).map(
    (link, index) => ({
      ...link,
      index,
    })
  )
  const internalLinksWithIndex = filterLinksForCodesAccess(internalLinks).map(
    (link, index) => ({
      ...link,
      index,
    })
  )
  const defaultLinksWithIndex = filterLinksForCodesAccess(defaultLinks).map(
    (link, index) => ({
      ...link,
      index,
    })
  )
  const viewerLinksWithIndex = filterLinksForCodesAccess(viewerLinks).map(
    (link, index) => ({
      ...link,
      index,
    })
  )

  useEffect(() => {
    if (isSongManagementTeam) {
      setSidebarLinks(songManagementTeamLinksWithIndex)
    } else if (isAdmin) {
      setSidebarLinks(adminLinksWithIndex)
    } else if (isInternal) {
      setSidebarLinks(internalLinksWithIndex)
    } else if (isSongReadOnly) {
      setSidebarLinks(viewerLinksWithIndex)
    } else {
      setSidebarLinks(defaultLinksWithIndex)
    }

    return () => {
      setSidebarLinks([])
    }
  }, [isAdmin, isInternal, isSongManagementTeam, hasCodesAccess, isSongReadOnly, canUseIngest])

  return { sidebarLinks }
}
